import React from 'react';
import { Switch, Route } from 'react-router-dom';

import BillingPackageList from './BillingPackageList';
import BillingPackageDetails from './BillingPackageDetails';
import BillingPackageCreation from './BillingPackageCreation/BillingPackageCreationContainer';
import { PendingDataProvider } from '../../providers/PendingData.provider';

import { BillingDetailsProvider } from '../../providers/BillingDetails.provider';
// comment no issue
const Routes = (): React.JSX.Element => (
  <Switch>
    <Route exact path="/billing-packages">
      <BillingPackageList />
    </Route>
    <Route exact path="/billing-packages-create">
      <PendingDataProvider>
        <BillingPackageCreation />
      </PendingDataProvider>
    </Route>
    <Route exact path="/billing-packages/create">
      <PendingDataProvider>
        <BillingPackageCreation />
      </PendingDataProvider>
    </Route>
    <Route path="/billing-packages/:resource/:id">
      <BillingDetailsProvider>
        <BillingPackageDetails />
      </BillingDetailsProvider>
    </Route>
  </Switch>
);

export default Routes;
